import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Contracts from './views/Contracts.vue'
import EditCompany from './views/EditCompany.vue'
import Company from './views/Company.vue'
import AddContract from './views/AddContract.vue'
import Contract from './views/Contract.vue'
import Offices from './views/Offices.vue'
import Office from './views/Office.vue'
import Teams from './views/Teams.vue'
import Team from './views/Team.vue'
import User from './views/User.vue'
import Users from './views/Users.vue'
import AddUsers from './views/AddUsers.vue'
import Administrators from './views/Administrators.vue'
import Administrator from './views/Administrator.vue'
import SystemAdministrators from './views/SystemAdministrators.vue'
import SystemAdministrator from './views/SystemAdministrator.vue'
import NoAccount from './views/NoAccount.vue'
Vue.use(Router)

const router = new Router({});

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.name) {
        // Start the route progress bar.
        NProgress.start()
    }
    next()
  })
  
  router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    NProgress.done()
  })

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            component: Home
        },
	{
            path: '/login',
            redirect: '/',
        },
        {
            path: '/edit-company',
            name: 'edit-company',
            component: EditCompany
        },
        {
            path: '/company',
            name: 'create-company',
            component: Company
        },
        {
            path: '/company/:id',
            name: 'update-company',
            component: Company
        },
        {
            path: '/contracts/:id',
            name: 'contracts',
            component: Contracts
        },
        {
            path: '/add-contract',
            name: 'add-contract',
            component: AddContract
        },{
            path: '/extend-contract/:id',
            name: 'extend-contract',
            component: Contract
        },
        {
            path: '/contract',
            name: 'create-contract',
            component: Contract
        },
        {
            path: '/contract/:id',
            name: 'update-contract',
            component: Contract
        },
        {
            path: '/offices',
            name: 'offices',
            component: Offices
        }, {
            path: '/office',
            name: 'office',
            component: Office
        }, {
            path: '/office/:id',
            name: 'update-office',
            component: Office
        },
        {
            path: '/teams',
            name: 'teams',
            component: Teams
        },
        {
            path: '/team',
            name: 'team',
            component: Team
        },
        {
            path: '/team/:id',
            name: 'update-team',
            component: Team
        },
        {
            path: '/user',
            name: 'create-user',
            component: User
        },
        {
            path: '/user/:id',
            name: 'update-user',
            component: User
        },
        {
            path: '/users',
            name: 'users',
            component: Users
        },
        {
            path: '/add-users',
            name: 'add-users',
            component: AddUsers
        },
        {
            path: '/administrators',
            name: 'administrators',
            component: Administrators
        },
        {
            path: '/administrator',
            name: 'create-administrator',
            component: Administrator
        },
        {
            path: '/administrator/:id',
            name: 'update-administrator',
            component: Administrator
        },
        {
            path: '/system-administrators',
            name: 'system-administrators',
            component: SystemAdministrators
        },
        {
            path: '/system-administrator/:id',
            name: 'update-system-administrator',
            component: SystemAdministrator
        },
        {
            path: '/system-administrator/',
            name: 'create-system-administrator',
            component: SystemAdministrator
        },
        {
            path: '/no-account',
            name: 'no-account',
            component: NoAccount
        },
    ]
})